var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.pageTemplate,{key:_vm.key,tag:"component",staticClass:"home"}),_c('newsletter-horizontal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }